import { Component, OnInit, OnDestroy, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { UsersService } from "../../services/users.service";
import { NgxSpinnerService } from "ngx-spinner";
import { Router, ActivatedRoute } from "@angular/router";
import { interval, Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';


export interface TimeSpan { hours: number; minutes: number; seconds: number; }
@Component({
  selector: 'app-viewer',
  templateUrl: './viewer.component.html',
  styleUrls: ['./viewer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ViewerComponent implements OnInit, OnDestroy {
  abc:any=50;view_button:any=0;
  firstFormGroup: any;completePercent:any=0; total_time_spent: any = 1;total_update_time_spents:any=0;total_update_time_spentss:any=0;viewStatus:Number=0; hours: any = ''; minutes: any = ''; seconds: any = ''; proPercent: any = 0;view:Number=0;
  secondFormGroup: any; userLoginData: any = []; modId: any = ''; subModlId: any = ''; capsuleData: any = ''; courseId: any = '';capsuleDataSubModulesData:any=[];
  activeTab = 0;
  subModuleData:any=[];

  constructor(private changeDetector: ChangeDetectorRef, private _formBuilder: FormBuilder, private router: Router, private authUser: UsersService, private route: ActivatedRoute, private spinner: NgxSpinnerService,
    private modalService: NgbModal,private toastr: ToastrService) {
    if (localStorage.getItem('userLoginData') == '' || localStorage.getItem('userLoginData') == null) {
      this.router.navigateByUrl('/');
    }
  }
  // Timer starts only after capsuleDetail() returns the saved server time.
  entries = new Date();
  elapsedTime: TimeSpan = { hours: 0, minutes: 0, seconds: 0 };
  private timerSubscription?: Subscription;
  private timerReady = false;
  private saveInFlight = false;
  private latestPendingTime: number | null = null;
  ngOnInit(): void {
    /******prevent Angular page refresh start */
    window.addEventListener("keyup", disableF5);
    window.addEventListener("keydown", disableF5);
    function disableF5(e:any) {  if ((e.which || e.keyCode) == 116) e.preventDefault(); };
    /****** End */
    this.firstFormGroup = this._formBuilder.group({ firstCtrl: ['', Validators.required] });
    this.secondFormGroup = this._formBuilder.group({ secondCtrl: ['', Validators.required] });

    this.userLoginData = JSON.parse(localStorage.getItem('userLoginData') || '[]');
    this.route.queryParams.subscribe(queryParams => {
      this.modId = queryParams['modId'];
      this.subModlId = queryParams['subModlId'];
      this.courseId = queryParams['courseId'];
      if(queryParams['view'] !=undefined){
        this.view = queryParams['view'];
      };
    });
    this.checkCoursesStatus(this.userLoginData.user_id,this.courseId);
    if ((this.userLoginData != '' || this.userLoginData != null) && (this.modId != '' || this.modId != null) && (this.subModlId != '' || this.subModlId != null)) {
      this.capsuleDetail(this.userLoginData.user_id, this.modId, this.subModlId);
      //this.startViewSubModule(this.userLoginData.user_id, this.courseId,this.modId,this.subModlId)
      this.sideMenuDetail(this.modId)
    }

    // getElapsedTime() is called explicitly every second, not by the HTML template.
    this.timerSubscription = interval(1000).subscribe(() => {
      if (!this.timerReady || this.view == 1 || this.view == 2) {
        return;
      }

      this.elapsedTime = this.getElapsedTime();
      this.subModuleTimeUpdate(
        this.userLoginData.user_id,
        this.courseId,
        this.modId,
        this.subModlId,
        this.total_update_time_spentss
      );
      this.changeDetector.markForCheck();
    });
  }
  open1(content: any) {
    this.modalService.open(content, { centered: true, size: 'sm', backdrop: 'static', keyboard: false  });
  }
  /*****get content capsule details *****/
  capsuleDetail(userId: any, modId: any, subModlId: any) {
    this.spinner.show();
    this.authUser.viewerSubModuleDetail(userId, modId, subModlId).subscribe(
      data => {
        this.spinner.hide();
        if(data.status == 401){
          document.getElementById('validationMsg')?.click();
        }else{
          this.capsuleData = data.data;
          //console.log(this.capsuleData,'hello')
          this.capsuleDataSubModulesData = data.data.subModules;

          // running_time is expected to be cumulative seconds from the API.
          const savedSeconds = Number(data.data.subModules.running_time);
          this.total_update_time_spents =
            Number.isFinite(savedSeconds) && savedSeconds > 0
              ? Math.floor(savedSeconds)
              : 0;

          // Reset the session start only after the saved time has loaded.
          this.entries = new Date();
          this.total_update_time_spentss = this.total_update_time_spents;
          this.timerReady = true;
          this.elapsedTime = this.getElapsedTime();

          this.completePercent = (100/this.capsuleData.subModules.media_data.length)*( this.capsuleData.subModules.last_index_seen);
          this.changeDetector.markForCheck();
          if(this.view==1){
            data.data.subModules.last_index_seen = 0;
          }
            this.spinner.hide();
        }

      }, error => {
        this.toastr.error('something went wrong');
        this.spinner.hide();
      }
    )
  }
  sideMenuDetail( modId: any) {
    this.spinner.show();
    this.authUser.sideMenuDetail(modId).subscribe(
      data => {
      console.log("SideMenuData:",data)
      if(data.success && data.status==200)
      this.subModuleData=data.module_data?.subModules

      }, error => {
        this.toastr.error('something went wrong');
        this.spinner.hide();
      }
    )
  }
  /*** Calculate cumulative elapsed time. Called once per second by RxJS. ***/
  getElapsedTime(): TimeSpan {
    const sessionSeconds = Math.floor(
      (Date.now() - this.entries.getTime()) / 1000
    );

    // Keep this value as the full cumulative seconds. Do not subtract hours/minutes
    // from it; finishSubModule() and goToAssessment() also need this total.
    const savedSeconds = Number(this.total_update_time_spents) || 0;
    const totalSeconds = Math.max(0, Math.floor(savedSeconds + sessionSeconds));
    this.total_update_time_spentss = totalSeconds;

    return {
      hours: Math.floor(totalSeconds / 3600),
      minutes: Math.floor((totalSeconds % 3600) / 60),
      seconds: totalSeconds % 60
    };
  }

  /*******reading end of content capsule or sub module ***/
  finishSubModule(index:any) {
    this.view_button=1;
    this.spinner.show();
    if(this.view==0){
     // this.total_time_spent = ((this.hours * 60) + this.minutes);
      this.total_time_spent = this.total_update_time_spentss;
      //if(this.total_time_spent < 1){ this.total_time_spent = 1; }
     this.finishViewSubModule(this.userLoginData.user_id, this.courseId, this.modId, this.subModlId, this.total_time_spent,index);
    //  this.router.navigate(['/assigned_details_resume'], { queryParams: { courseId: this.capsuleData.subModules.course_id } });
    }else if(this.view==2){
       this.router.navigate(['/completed_details'], { queryParams: { courseId: this.capsuleData.subModules.course_id } });
       this.spinner.hide();
    }else{
       this.router.navigate(['/assigned_details_resume'], { queryParams: { courseId: this.capsuleData.subModules.course_id } });
       this.spinner.hide();
     }
  }
  /******reading end of sub module and redirect to take assessment */
  goToAssessment(index:any) {
    this.view_button=1;
    this.spinner.show();
   // this.total_time_spent = ((this.hours * 60) + this.minutes);
    this.total_time_spent = this.total_update_time_spentss;
   // if(this.total_time_spent < 1){ this.total_time_spent = 1; }
    this.finishViewSubModule(this.userLoginData.user_id, this.courseId, this.modId, this.subModlId, this.total_time_spent,index);
  }
  /**finish submodule reading and update percentage and time spent */
  finishViewSubModule(userId: any, course_id: any, module_id: any, submodule_id: any, totalTimeSpent: any,index:any) {
    this.spinner.show();
    /*******update submodule reading index */
    this.nextSlide(index, submodule_id);
    this.authUser.subModuleEndView(userId, course_id, module_id, submodule_id, totalTimeSpent).subscribe(
      data => {
        if(data.status == 401){
          document.getElementById('validationMsg')?.click();
          this.spinner.hide();
        }else{
          this.moduleProgressPercent(submodule_id,this.modId);
          if (this.capsuleData.subModules.assessment_id != '' && this.capsuleData.subModules.assessment_id != null) {
            localStorage.setItem('totalTimeSpent', JSON.stringify(totalTimeSpent));
            this.router.navigate(['/viewer-details'], { queryParams: { course_id: course_id, module_id: module_id, submodule_id: submodule_id, assId: this.capsuleData.subModules.assessment_id,AT:0 } });
            this.spinner.hide();
          }else{
            this.router.navigate(['/assigned_details_resume'], { queryParams: { courseId: this.capsuleData.subModules.course_id } });
            this.spinner.hide();
          }
        }
      }, error => {
        this.spinner.hide();
        this.toastr.error('something went wrong');
      }
    )
  }
  /**** Persist the latest cumulative time; avoid overlapping requests/out-of-order writes. */
  subModuleTimeUpdate(user_id:number, course_id:any, module_id:any, submodule_id:any, total_time_spent:any): void {
    const seconds = Math.max(0, Math.floor(Number(total_time_spent) || 0));
    this.latestPendingTime = seconds;

    if (this.saveInFlight) {
      return;
    }

    this.saveInFlight = true;
    const sendLatest = () => {
      const valueToSave = this.latestPendingTime;
      this.latestPendingTime = null;

      if (valueToSave === null) {
        this.saveInFlight = false;
        return;
      }

      this.authUser.subModuleTimeUpdate(
        user_id, course_id, module_id, submodule_id, valueToSave
      ).subscribe({
        next: () => {
          // If a newer second elapsed during this request, send the latest total now.
          if (this.latestPendingTime !== null) {
            sendLatest();
          } else {
            this.saveInFlight = false;
          }
        },
        error: () => {
          this.saveInFlight = false;
          // Keep the latest total queued; the next timer tick will retry it.
          this.latestPendingTime = Math.max(
            this.latestPendingTime ?? 0,
            valueToSave
          );
          // Avoid showing a toast every second for a transient network failure.
          console.error('Failed to save submodule time.');
        }
      });
    };

    sendLatest();
  }

  /******function for switch next capsule content */
  nextSlide(index: any, submodule: any) {
   // this.spinner.show();
    //this.moduleProgressPercent(submodule,this.modId);
   //console.log(this.capsuleData.subModules.last_index_see,index);
   this.authUser.checkCourseStatus(this.userLoginData.user_id,this.courseId).subscribe(
    data=>{
      // debugger
    if(data.exits == 0){
      this.router.navigateByUrl('/assigned');
    }else{
      if(this.view == 0){
        //if(this.capsuleData.subModules.last_index_seen <= index)
          this.completePercent = (100/this.capsuleData.subModules.media_data.length)*( index);
         // this.spinner.show();
          this.authUser.subModuleIndex(this.userLoginData.user_id, this.courseId,this.modId, index, submodule).subscribe(
            data => {
              if(data.status == 401){
                document.getElementById('validationMsg')?.click();
                this.spinner.hide();
              }else{
                this.moduleProgressPercent(submodule,this.modId);
                this.spinner.hide();
              //this.capsuleDetails(this.userLoginData.user_id, this.modId, this.subModlId);
              }

            }, error => {
              this.spinner.hide();
              this.toastr.error('something went wrong');
            }
          )
        }
    }

    },error=>{
      this.spinner.hide();
    }
  )

  }
  moduleProgressPercent(submodule:any,modId:any){
    this.authUser.moduleProgress(this.userLoginData.user_id, this.courseId,modId,submodule).subscribe(
      data => {
        this.spinner.hide();
        //this.capsuleDetails(this.userLoginData.user_id, this.modId, this.subModlId);
      }, error => {
        this.spinner.hide();
        this.toastr.error('something went wrong in module');
      }
    )

  }
  navigationEvent() {
    localStorage.removeItem('userLoginData');
    this.router.navigateByUrl('/');

    }
    /****incase admin make course deactive than check and redirect to assign list */
    checkCoursesStatus(user_id:number,course_id:any){
      this.spinner.show();
      this.authUser.checkCourseStatus(user_id,course_id).subscribe(
        data=>{
        if(data.exits == 0){
          this.router.navigateByUrl('/assigned');
        }
        this.spinner.hide();
        },error=>{
          this.spinner.hide();
        }
      )
    }
  ngOnDestroy(): void {
    this.timerSubscription?.unsubscribe();
    this.timerReady = false;
  }
}
